import { Layout, Menu } from 'antd';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';
import { css } from 'emotion';
import { inject, observer } from 'mobx-react';
import { ApplicationStore, AuthenticationStore, PharmacyDetailedStore, SecretariatStore } from '../../store';
import { SystemStatusStore } from '../../store/SystemStatusStore';
import { SystemStatusSubSystem } from '../../common/enums/SystemStatusSubSystem';
import { Instance } from 'mobx-state-tree';
import { ActionCode, Page, TLCode } from '../../common/enums';
import RightContent from './header/RightContent';
import { NavigationItem } from './NavigationItem';
import { ProtectedNavigationItem } from './ProtectedNavigationItem';
import { SystemStatus } from '../../store/models/SystemStatus';
import PushNotification from '../common/PushNotification';
import { PushNotificationStore } from '../../store/PushNotificationStore';
import { getSecretariatLogo } from '../../common/secretariatUtils';

const { Header, Content, Footer, Sider } = Layout;

interface SliderLayoutProps extends RouteComponentProps<string> {
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  SystemStatusStore?: Instance<typeof SystemStatusStore>;
  PushNotificationStore?: Instance<typeof PushNotificationStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  children?: JSX.Element[] | JSX.Element;
}

interface SliderlayoutState {
  systemStatus?: Array<Instance<typeof SystemStatus>>;
  transferModuleMode?: string;
  collapsed?: boolean;
  userCount?: number;
}

@inject('AuthenticationStore')
@inject('ApplicationStore')
@inject('SystemStatusStore')
@inject('PushNotificationStore')
@inject('PharmacyDetailedStore')
@inject('SecretariatStore')
@observer
class SliderLayout extends React.Component<SliderLayoutProps, SliderlayoutState> {
  state = {
    collapsed: false,
    userCount: this.props.PushNotificationStore!.userCount,
    transferModuleMode: 'standard',
  } as SliderlayoutState;

  async componentDidMount() {
    const criteriaBP: any = {
      subSystem: SystemStatusSubSystem.ACCESS,
    };
    const transferModuleMode = await this.props.ApplicationStore!.getTransferModuleMode();
    const systemStatus = await this.props.SystemStatusStore!.search(criteriaBP);
    // @ts-ignore
    this.setState({ systemStatus, transferModuleMode });
    this.props.PushNotificationStore!.connect(this.props.AuthenticationStore!.userName);
  }
  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  private getSecretariatLogo = () => {
    let secretariatId = 1;
    if (this.props.AuthenticationStore!.isSecretariat && this.props.AuthenticationStore!.secretariatId !== null) {
      secretariatId = this.props.AuthenticationStore!.secretariatId;
    }
    if (this.props.AuthenticationStore!.isPharmacy && this.props.AuthenticationStore!.pharmacyId !== null) {
      const pharmacy = this.props!.PharmacyDetailedStore!.getById(this.props.AuthenticationStore!.pharmacyId);
      if (pharmacy !== undefined && pharmacy.secretariatId !== undefined) {
        secretariatId = pharmacy.secretariatId;
      }
    }
    const secretariat = this.props.SecretariatStore!.getById(secretariatId);
    return getSecretariatLogo(secretariat);
  };

  render() {
    const { userActionCodes, isLoggedIn, isSuperAdmin, isAdmin, isSecretariat } = this.props.AuthenticationStore!;
    const { userCount } = this.state;
    const status = this.state.systemStatus
      ? this.state.systemStatus!.length > 0
        ? this.state.systemStatus![0].status
        : 'Limited'
      : 'Limited'; //  .find((elem) => elem.year === 2019 && elem.subSystem === 'Exchange');
    const transferModuleMode = this.state.transferModuleMode;

    return (
      <div>
        <Layout tagName="main" style={{ minHeight: '100vh', minWidth: '100hw' }}>
          <Header tagName="header" className="header">
            <div
              className={css({
                width: '120px',
                height: '31px',
                background: 'white', // 'rgba(255,255,255,.2)',
                margin: '16px 28px 16px 0',
                padding: '0px 0px 0px 0px',
                float: 'left',
              })}
            >
              <a href="http://www.uphoc.be" target="_blank">
                <img
                  src={this.getSecretariatLogo()}
                  height={31}
                  className={css({
                    verticalAlign: 'top',
                    textAlign: 'center',
                    // paddingTop: 5,
                    // paddingLeft: 15,
                  })}
                />
              </a>
            </div>
            <span className={css({ color: 'white', fontSize: '30px', paddingLeft: '190px' })}>
            {transferModuleMode == 'standard' && 'Pharmagarde'}{transferModuleMode == 'dedicated' && 'Pharmamove'}</span>
            <RightContent />
          </Header>
          <Layout tagName="main" style={{ minHeight: '90vh' }}>
            <Sider
              theme="light"
              collapsible={true}
              collapsed={this.state.collapsed}
              onCollapse={this.onCollapse}
              breakpoint="lg"
              className={css({
                textAlign: 'left',
              })}
            >
              <Menu theme="light" defaultSelectedKeys={['1']} mode="inline">
                <NavigationItem icon={'home'} page={Page.Home} textTlCode={TLCode.HomePage} />
                {(status == 'Full' && transferModuleMode != 'dedicated') ||
                (status == 'Limited' && isSecretariat && transferModuleMode != 'dedicated') ||
                isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.SECRETARY_USER_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'dashboard'}
                    page={Page.SecretariatDashboard}
                    textTlCode={TLCode.SECRETARIAT_DASHBOARD_Title}
                  />
                ) : null}
                {(status == 'Full' && transferModuleMode != 'dedicated') || isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.PHARMACY_USER_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'medicine-box'}
                    page={Page.PharmacyPage + '/' + this.props.AuthenticationStore!.pharmacyId}
                    textTlCode={TLCode.MY_PHARMACY}
                  />
                ) : null}
                {(status == 'Full' && transferModuleMode != 'dedicated') ||
                (status == 'Limited' && isSecretariat && transferModuleMode != 'dedicated') ||
                isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE, ActionCode.PHARMACY_USER_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'swap'}
                    page={Page.Exchanges}
                    textTlCode={TLCode.ExchangePage}
                  />
                ) : null}
                {false &&
                ((status == 'Full' && transferModuleMode != 'dedicated') ||
                  (status == 'Limited' && isSecretariat && transferModuleMode != 'dedicated') ||
                  isSuperAdmin) ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'stop'}
                    page={Page.BlackPoints}
                    textTlCode={TLCode.BlackPointPage}
                  />
                ) : null}
                {(status == 'Full' && transferModuleMode != 'dedicated') ||
                (status == 'Limited' && isSecretariat && transferModuleMode != 'dedicated') ||
                isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'calendar'}
                    page={Page.Duties}
                    textTlCode={TLCode.DutyPage}
                  />
                ) : null}
                <ProtectedNavigationItem
                  requiredRoles={[ActionCode.SUPER_ADMIN_CODE]}
                  userRoles={userActionCodes}
                  isLoggedIn={isLoggedIn}
                  icon={'schedule'}
                  page={Page.Planner}
                  textTlCode={TLCode.PlannerPage}
                />
                {(status == 'Full' && transferModuleMode != 'dedicated') ||
                (status == 'Limited' && isSecretariat && transferModuleMode != 'dedicated') ||
                isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'medicine-box'}
                    page={Page.Pharmacies}
                    textTlCode={TLCode.PharmacyPage}
                  />
                ) : null}
                {/* {status == 'Full' || (status == 'Limited' && isSecretariat) || isSuperAdmin ? (*/}
                {isSuperAdmin || isAdmin || isSecretariat ? (
                  transferModuleMode == 'standard'?
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'medicine-box'}
                    page={Page.Transfers}
                    textTlCode={TLCode.Pharmamove}
                  />:
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'medicine-box'}
                    page={Page.Transfers}
                    textTlCode={TLCode.TransferPage}
                  />
                ) : null}
                {/* <ProtectedNavigationItem
                  requiredRoles={[ActionCode.SUPER_ADMIN_CODE, ActionCode.PHARMACY_USER_CODE]}
                  userRoles={userActionCodes}
                  isLoggedIn={isLoggedIn}
                  icon={'stop'}
                  page={Page.MyPharmacy}
                  textTlCode={TLCode.MyPharmacyPage}
                /> */}

                {/* <ProtectedNavigationItem
                  requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                  userRoles={userActionCodes}
                  isLoggedIn={isLoggedIn}
                  icon={'global'}
                  page={Page.Zones}
                  textTlCode={TLCode.ZonePage}
                /> */}
                {((status == 'Full' || status == 'Limited') && transferModuleMode != 'dedicated') || isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'team'}
                    page={Page.Users}
                    textTlCode={TLCode.UserPage}
                  />
                ) : null}
                {((status == 'Full' || status == 'Limited') && transferModuleMode != 'dedicated') || isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'desktop'}
                    page={Page.Secretariats}
                    textTlCode={TLCode.SecretariatPage}
                  />
                ) : null}
                {((status == 'Full' || status == 'Limited') && transferModuleMode != 'dedicated') || isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'desktop'}
                    page={Page.Groups}
                    textTlCode={TLCode.GroupPage}
                  />
                ) : null}
                {((status == 'Full' || status == 'Limited') && transferModuleMode != 'dedicated') || isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'file-search'} //monitor file-search tools settings
                    page={Page.Diagnostic}
                    textTlCode={TLCode.ANALYSIS_MENU_ENTRY}
                  />
                ) : null}
                {((status == 'Full' || status == 'Limited') && transferModuleMode != 'dedicated') || isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'file-search'} //monitor file-search tools settings
                    page={Page.DutyAssignment}
                    textTlCode={TLCode.QUICK_DUTY_PAGE}
                  />
                ) : null}
                {((status == 'Full' || status == 'Limited') && transferModuleMode != 'dedicated') || isSuperAdmin ? (
                  <ProtectedNavigationItem
                    requiredRoles={[ActionCode.ADMIN_CODE, ActionCode.SUPER_ADMIN_CODE]}
                    userRoles={userActionCodes}
                    isLoggedIn={isLoggedIn}
                    icon={'file-search'} //monitor file-search tools settings
                    page={Page.CalendarComparisonPage}
                    textTlCode={TLCode.CALENDAR_COMPARISON_PAGE}
                  />
                ) : null}
              </Menu>
            </Sider>
            <Layout tagName="main" style={{ padding: '12px 12px 0px 12px', textAlign: 'left' }}>
              <Content
                tagName="section"
                style={{
                  background: '#fff',
                  margin: 0,
                  minHeight: 280,
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {this.props.children}
              </Content>
              <Footer tagName="footer" className="footer">
                {transferModuleMode == 'dedicated' && (
                  <div>
                    PharmaMove v{this.props.ApplicationStore!.appVersion}
                    &nbsp;&nbsp;©{(new Date()).getFullYear()} UPHOC&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;powered by Pulsar
                  </div>
                )}
                {transferModuleMode != 'dedicated' && (
                  <div>
                    Pharmagarde v{this.props.ApplicationStore!.appVersion}
                    &nbsp;&nbsp;©{(new Date()).getFullYear()} UPHOC&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;powered by Pulsar
                  </div>
                )}
                <span style={{ float: 'right' }}>
                  env:&nbsp;{process.env.REACT_APP_ENV}
                  {this.props.ApplicationStore!.mailRedirection !== '' && (
                    <span style={{ color: 'red', marginLeft: '5px' }}>
                      Email redirected to {this.props.ApplicationStore!.mailRedirection}
                    </span>
                  )}
                </span>
              </Footer>
              <PushNotification></PushNotification>
            </Layout>
          </Layout>
        </Layout>
      </div>
    );
  }
}

export default withRouter(SliderLayout);
